module.exports = __webpack_public_path__ + "img/belgium-diabetes-mellitus-female.198de4db.png";